<template>
  <div class="container">
    <div class="nav">
      <img src="~@/assets/img/product/banner.png" alt="" class="bg">
      <div class="main">
        <div class="left">
          <p class="title">传播高品质文化的艺术交流平台</p>
          <p class="title1">为艺术家、非物质文化传承人、艺术收藏爱好者、艺术赞助机构、艺术研究机构， 构建一个交流、推广、互动的多元化平台。</p>
        </div>
        <div class="right">
          <div class="l-right">
            <div class="item" @click="toDownload()">
              <img src="~@/assets/img/product/ios.png" alt="">
              <span>iPhone 版下载</span>
            </div>
            <div class="item" @click="toDownload()">
              <img src="~@/assets/img/product/android.png" alt="">
              <span>Android 版下载</span>
            </div>
          </div>
          <img src="~@/assets/img/product/app@2x.png" alt="" class="r-right">
        </div>
      </div>
    </div>
    <div class="foot">
      <div class="allBg">
        <img src="~@/assets/img/product/bg1@2x.png" alt="">
        <img src="~@/assets/img/product/bg2@2x.png" alt="">
        <img src="~@/assets/img/product/bg3@2x.png" alt="">
        <img src="~@/assets/img/product/bg4@2x.png" alt="">
      </div>
      <div class="main">
        <div class="part1">
          <div class="commonText">
            <p class="title">藏品拍卖</p>
            <p class="title1">自由设置起拍价格及每次竞价</p>
          </div>
          <div class="circle1">人民币</div>
          <div class="circle2">纪念币</div>
          <img src="~@/assets/img/product/zisha@2x.png" alt="" class="img1">
          <img src="~@/assets/img/product/app1@2x.png" alt="" class="img2">
        </div>

        <div class="part2">
          <div class="commonText">
            <p class="title">直播卖货</p>
            <p class="title1">直播卖货 开启您的直播卖货之旅</p>
          </div>
          <div class="circle1">和田玉</div>
          <div class="circle2">琥珀蜜蜡</div>
          <div class="circle3">松石</div>
          <div class="circle4">翡翠</div>
          <img src="~@/assets/img/product/app2@2x.png" alt="" class="img1">
          <img src="~@/assets/img/product/pixiu@2x.png" alt="" class="img2">
        </div>

        <div class="part3">
          <div class="commonText">
            <p class="title">藏友交流</p>
            <p class="title1">寻找圈内志同道合的藏友</p>
          </div>
          <div class="circle1">钧瓷</div>
          <div class="circle2">青瓷</div>
          <img src="~@/assets/img/product/dog@2x.png" alt="" class="img1">
          <img src="~@/assets/img/product/app3@2x.png" alt="" class="img2">
        </div>

        <div class="part4">
          <div class="commonText">
            <p class="title">分享赚钱</p>
            <p class="title1">自买省钱，分享赚钱</p>
          </div>
          <div class="circle1">木质<br>手串</div>
          <div class="circle2">琥珀</div>
          <img src="~@/assets/img/product/app4@2x.png" alt="" class="img1">
          <img src="~@/assets/img/product/rabbit@2x.png" alt="" class="img2">
        </div>

         <div class="part5">
          <div class="commonText">
            <p class="title">鉴定瑰宝</p>
            <p class="title1">发现民间艺术瑰宝</p>
          </div>
          <div class="circle1">
            <p class="title">唐恺</p>
            <p class="title1">鉴宝专家</p>
          </div>
          <div class="circle2">
            <p class="title">李斌</p>
            <p class="title1">鉴宝专家</p>
          </div>
          <img src="~@/assets/img/product/ci@2x.png" alt="" class="img1">
          <img src="~@/assets/img/product/app5@2x.png" alt="" class="img2">
        </div>

      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'product',
  data () {
    return {
      
    }
  },
  methods:{
    toDownload(){
      window.location.href ='https://www.51ysscw.com/system/#/download';
    }
  }
}
</script>  

<style lang="scss" scoped>
.container{
  padding-top: 60px;
  .nav{
    width: 100%;
    height: 240px;
    position: relative;
    .bg{
      width: 100%;
      height: 240px;
      position: absolute;
      top: 0;
      left: 0;
    }
    .main{
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;
      position: relative;
      z-index: 1;
      width: 1200px;
      margin: 0 auto;
      .right{
        display: flex;
        .l-right{
          display: inline-block;
          margin-right: 16px;
          .item{
            margin-bottom: 24px;
            width: 192px;
            height: 48px;
            background: #D5262B;
            border-radius: 4px;
            display: flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;
            img{
              width: 14px;
              height: 16px;
              margin-right: 8px;
            }
            span{
              font-size: 16px;
              color: #FFFFFF;
            }
          }
        }
        .r-right{
          width: 120px;
        }
      }
      .left{
        width: 640px;
        .title{
          font-size: 30px;
          font-weight: bold;
          color: #FFFFFF;
          margin-bottom: 19px;
        }
        .title1{
          font-size: 18px;
          line-height: 30px;
          color: #F2F2F2;
        }
      }
    }
  }
  .foot{
    position: relative;
    margin-top: 60px;
    .allBg{
      position: absolute;
      top:0;
      left: 0;
      img{
        width: 100%;
        display: block;
        position: relative;
        &:nth-child(1){
          height: 804px;
        }
        &:nth-child(2){
          height: 1296px;
          top: -50px;
        }
         &:nth-child(3){
          height: 905px;
          top: -220px;
        }
         &:nth-child(4){
          height: 816px;
          top: -250px;
        }
      }
    }
    .main{
      width: 1200px;
      margin: 0 auto;
      position: relative;
      z-index: 1;
      .commonText{
        .title{
          font-size: 28px;
          font-weight: bold;
          color: #FFFFFF;
          margin-bottom: 20px;
          padding-bottom: 20px;
          position: relative;
          &::after{
            content:'';
            height: 2px;
            width: 70px;
            background: #fff;
            border-radius: 1px;
            position: absolute;
            bottom: 0;
            left: 0;
          }
        }
        .title1{
          font-size: 16px;
          color: #F2F2F2;
        }
      }
      .part1{
        position: relative;
        height: 600px;
        .commonText{
          position: absolute;
          left: 280px;
          top: 140px;
        }
        .circle1{
          width: 77px;
          height: 77px;
          background: radial-gradient(#e35d5be3, #fd3828);
          border-radius: 50%;
          text-align: center;
          line-height: 77px;
          font-size: 19px;
          font-weight: 500;
          color: #E8D192;
          position: absolute;
          left: 370px;
          top: -30px;
        }
        .circle2{
          width: 58px;
          height:58px;
          background: radial-gradient(#e35d5be3, #fd3828);
          border-radius: 50%;
          text-align: center;
          line-height: 58px;  
          font-size: 14px;
          color: #E8D192;
          position: absolute;
          left: 450px;
          top: 100px;
        }
        .img1{
          position: absolute;
          width: 516px;
          height: 330px;
          top:280px;
        }
        .img2{
          position: absolute;
          width: 492px;
          height: 539px;
          left: 530px;
          top:-30px ;
        }
      }
      .part2{
        position: relative;
        height: 550px;
        .commonText{
          position: absolute;
          left: 650px;
          top: 350px;
        }
        .circle1{
          width: 72px;
          height: 72px;
          background: radial-gradient(#e35d5be3, #fd3828);
          opacity: 0.96;
          border-radius: 50%;
          text-align: center;
          line-height: 72px;
          font-size: 19px;
          font-weight: 500;
          color: #E8D192;
          position: absolute;
          left: 150px;
          top: 300px;
        }
        .circle2{
          width: 120px;
          height: 120px;
          background:radial-gradient(#e35d5be3, #fd3828);
          border-radius: 50%;
          text-align: center;
          line-height: 120px;  
          font-size: 26px;
          color: #E8D192;
          position: absolute;
          left: 920px;
          top: 65px;
        }
        .circle3{
          width: 72px;
          height: 72px;
          background:radial-gradient(#e35d5be3, #fd3828);
          opacity: 0.96;
          border-radius: 50%;
          text-align: center;
          line-height: 72px;
          font-size: 19px;
          font-weight: 500;
          color: #E8D192;
          position: absolute;
          left: 1030px;
          top: 155px;
        }
        .circle4{
          width: 77px;
          height: 77px;
          background: radial-gradient(#e35d5be3, #fd3828);
          opacity: 0.96;
          border-radius: 50%;
          text-align: center;
          line-height: 77px;
          font-size: 19px;
          font-weight: 500;
          color: #E8D192;
          position: absolute;
          left: 980px;
          top: 300px;
        }
        .img1{
          position: absolute;
          width: 480px;
          height:588px;
          left: 200px;
        }
        .img2{
          position: absolute;
          width: 400px;
          height: 241px;
          left: 500px;
          top: 50px;
        }
      }
      .part3{
        position: relative;
        height: 800px;
        .commonText{
          position: absolute;
          left: 300px;
          top: 70px;
        }
        .circle1{
          width: 65px;
          height:65px;
          background: radial-gradient(#e35d5be3, #fd3828);
          border-radius: 50%;
          text-align: center;
          line-height: 65px;
          font-size: 18px;
          font-weight: 500;
          color: #E8D192;
          position: absolute;
          left:530px;
          top: -10px;
        }
        .circle2{
          width: 58px;
          height:58px;
          background:radial-gradient(#e35d5be3, #fd3828);
          border-radius: 50%;
          text-align: center;
          line-height: 58px;  
          font-size: 14px;
          color: #E8D192;
          position: absolute;
          left: 170px;
          top: 300px;
        }
        .img1{
          position: absolute;
          width: 449px;
          height: 390px;
          top: 240px;
          left: 230px;
        }
        .img2{
          position: absolute;
          width: 460px;
          height: 663px;
          left: 630px;
          top:-30px ;
        }
      }
      .part4{
        position: relative;
        height: 900px;
        .commonText{
          position: absolute;
          right: 180px;
          top: 270px;
        }
        .circle1{
          width: 72px;
          height:72px;
          background: radial-gradient(#e35d5be3, #fd3828);
          border-radius: 50%;
          display: flex;
          justify-content: center;
          align-items: center;
          font-size: 18px;
          font-weight: 500;
          color: #E8D192;
          position: absolute;
          right:280px;
          top:100px;
        }
        .circle2{
          width: 77px;
          height:77px;
          background: radial-gradient(#e35d5be3, #fd3828);
          border-radius: 50%;
          text-align: center;
          line-height:77px;  
          font-size: 19px;
          color: #E8D192;
          position: absolute;
          right:40px;
          top: 240px;
        }
        .img1{
          position: absolute;
          width: 1029px;
          height: 771px;
          top: 0;
          left: -100px;
        }
        .img2{
          position: absolute;
          width: 367px;
          height: 317px;
          right:90px;
          bottom:150px ;
        }
      }
      .part5{
        position: relative;
        height: 690px;
        .commonText{
          position: absolute;
          left: 280px;
          top:50px
        }
        .circle1{
          width: 128px;
          height:128px;
          background: radial-gradient( #E35D5B,#EF473A);
          border-radius: 50%;
          text-align: center;
          font-size: 18px;
          font-weight: 500;
          color: #E8D192;
          position: absolute;
          left: 80px;
          top: 150px;
          .title{
            font-size: 25px;
            margin-bottom: 5px;
            margin-top: 30px;
          }
          .title1{
            font-size: 18px;
          }
        }
        .circle2{
          width: 77px;
          height:77px;
          background: radial-gradient(circle, #E35D5B 0%, #EF473A 100%);
          border-radius: 50%;
          text-align: center;
          font-size: 19px;
          color: #E8D192;
          position: absolute;
          left: 540px;
          top: 60px;
          z-index: 1;
          .title{
            font-size: 18px;
            margin-top:15px;
          }
          .title1{
            font-size: 14px;
          }
        }
        .img1{
          position: absolute;
          width: 322px;
          height: 460px;
          left: 190px;
          top: 200px;
        }
        .img2{
          position: absolute;
          width: 637px;
          height: 713px;
          left: 580px;
          top: -30px;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/page/product/main.vue